import { track } from "../../config/amplitude";

const FEATURE = "supplier_intelligence_promo";
const url = () => window.location.pathname;

export function trackSIPromoShown(
  promoType: "banner" | "tooltip" | "infocard" | "chip",
  promoId: string,
  surface: string
) {
  track("promo_shown", {
    feature: FEATURE,
    promo_type: promoType,
    promo_id: promoId,
    surface,
    page_url: url(),
  });
}

export function trackSIPromoDismissed(
  promoType: "banner" | "tooltip" | "infocard",
  promoId: string,
  surface: string
) {
  track("promo_dismissed", {
    feature: FEATURE,
    promo_type: promoType,
    promo_id: promoId,
    surface,
    page_url: url(),
  });
}

export function trackSIPromoButtonClicked(ctaText: string, section: string) {
  track("button_clicked", {
    feature: FEATURE,
    cta_text: ctaText,
    section,
    page_url: url(),
  });
}
